import * as React from "react";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

//MUI Icons

//Custom Components
import DialogActionButton from "@/ui/Dialog/DialogActionButton";

//Types
import { IDialogActionButtonDetail } from "@/@types/ui/Dialog";
import { Check } from "@mui/icons-material";

const DialogActionButtonOK: FunctionComponent<IDialogActionButtonDetail> = (props) => {
  const { t } = useTranslation();

  return (
    <DialogActionButton startIcon={<Check />} {...props} ariaLabel="Save" ariaControls="Save">
      {t("buttons.ok")}
    </DialogActionButton>
  );
};

export default DialogActionButtonOK;
